import appSlice from './app.slice';

export const { setFlyerLanguage, setPageHeaderHeight } = appSlice.actions;
